import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CircularProgress, Box, Typography } from '@mui/material';
import { authService } from '../../services/auth';

const Callback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        if (!code) {
          throw new Error('No authorization code found');
        }

        await authService.handleCallback(code);
        navigate('/dashboard');
      } catch (error) {

        navigate('/login', { state: { error: 'Authentication failed' } });
      }
    };

    handleCallback();
  }, [navigate, searchParams]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
    >
      <CircularProgress size={60} />
      <Typography variant="h6" style={{ marginTop: 20 }}>
        Đang xử lý đăng nhập...
      </Typography>
    </Box>
  );
};

export default Callback; 